import { Resource } from 'ngx-jsonapi';

/**
 * Framework-agnostic `Network` resource for the `systems` capability.
 * Mirrors the `attributes` of the legacy `@app/core/resources/networks.ts`,
 * without its `relationships.systems` back-reference (no consumer needs it).
 */
export class Network extends Resource {
    public type: string = 'networks';
    public attributes: {
        title: string | null;
        fixed_fee_usd: number;
    } = {
        title: null,
        fixed_fee_usd: 0,
    };
}
